'use strict';

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readFloatLE('data.params.osl');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/ai-osl-parser.js